/* MV Sortiment assets/mv-sortiment.programm.js - Agent P-E - 2026-10-07 */
/*
  Modul "programm" fuer Empfehlungs- und Partnerprogramm (sections/mv-empfehlung.liquid,
  sections/mv-partnerprogramm.liquid, snippets/mv-bewerbung-formular.liquid). Teil von assets/mv-sortiment.js
  (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge; nur Delegation auf document, Zustand nur im DOM.

  1. Praemienrechner [data-mv-praemie] (Wurzel traegt zusaetzlich data-mv-rechner="praemie" als Rechner-Kennung der
     Pruefregeln; die Haken des Moduls "rechner" kommen darin nicht vor): Zahlen nur aus dem JSON-Datenblock
     script[data-mv-praemie-daten] ({"praemie_1", "praemie_ab_3", "staffel_ab"}), das Skript nennt keine Betraege.
     Der Regler [data-mv-praemie-steuerung] ist serverseitig hidden und wird hier freigeschaltet; jede Eingabe
     schreibt Anzahl, Summe und Rechenweg (nur textContent) und aria-valuetext. Ohne JS bleibt das von Liquid
     gerechnete Beispiel stehen.
  2. Bewerbungsformular [data-mv-bewerbung="<form-id>"]: Shopify markiert nach einem Kontakt-Post jedes
     Kontaktformular der Seite als gesendet (form.posted_successfully?); welches Formular gesendet hat, steht nur
     im Anker der Rueckleitung (?contact_posted=true#<form-id>). Fremder Post (z. B. #mv-anfrage-form der
     Lightbox): Dank bzw. Fehlermeldung des Bewerbungsformulars ausblenden, Felder zeigen. Eigener Post: die
     Lightbox, die ihr Skript wegen desselben Zustands mitgeoeffnet hat, schliessen, Fokus auf den Dank,
     Ereignis mv_bewerbung_gesendet ({programm, pfad}) per Shopify.analytics.publish.
  3. Partnerstufen: Knoepfe a[data-mv-partnerstufe="<Option>"] waehlen die Stufe im Formular vor
     (select[data-mv-partnerstufe-wahl]); der Sprung zum Anker #bewerbung bleibt Sache des Browsers.
  Reine Funktionen (praemienSumme, aufteilung, formatZahl, betragText, anzahlText, rechnungText, postZustand)
  sind unter Node ueber module.exports pruefbar (_tests/pe-programm.test.mjs). Waechter
  window.__mvSortiment.programm. Sichtbare Texte als \u-Escapes (Datei bleibt ASCII). Kommentare ASCII.
*/
;(function () {
  'use strict';

  var VERSION = '2026-10-07.1';
  var STAFFEL_AB = 3;
  var NBSP = '\u00a0';
  var EURO = '\u20ac';
  var MAL = '\u00d7';
  var TEXTE = {
    automat: 'Automat',
    automaten: 'Automaten'
  };

  function ganzeZahl(wert) {
    if (wert === null || wert === undefined || wert === '') return NaN;
    var n = Number(wert);
    return isFinite(n) ? Math.round(n) : NaN;
  }

  function betrag(wert) {
    if (wert === null || wert === undefined || wert === '') return NaN;
    var n = Number(wert);
    return isFinite(n) && n >= 0 ? n : NaN;
  }

  /* Automaten vor und ab der Staffel: 5 -> { vor: 2, ab: 3 } */
  function aufteilung(anzahl) {
    var n = ganzeZahl(anzahl);
    if (!isFinite(n) || n <= 0) return { vor: 0, ab: 0 };
    var grenze = STAFFEL_AB - 1;
    return { vor: Math.min(n, grenze), ab: Math.max(0, n - grenze) };
  }

  /* Praemiensumme nach Staffel: der erste und zweite Automat je praemie1, ab dem dritten je praemieAb3.
     Ungueltige Anzahl (<= 0, keine Zahl) oder ungueltige Praemie ergibt 0. */
  function praemienSumme(anzahl, praemie1, praemieAb3) {
    var p1 = betrag(praemie1);
    var p3 = betrag(praemieAb3);
    var a = aufteilung(anzahl);
    if (!isFinite(p1) || !isFinite(p3) || a.vor + a.ab === 0) return 0;
    return a.vor * p1 + a.ab * p3;
  }

  /* Ganze Zahl mit Tausenderpunkt ("2.800"); deterministisch ohne Intl */
  function formatZahl(n) {
    var z = Math.round(Math.abs(Number(n) || 0));
    var text = String(z).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return Number(n) < 0 ? '-' + text : text;
  }

  function betragText(n) {
    return formatZahl(n) + NBSP + EURO;
  }

  function anzahlText(anzahl) {
    var n = ganzeZahl(anzahl);
    if (!isFinite(n)) n = 0;
    return n + NBSP + (n === 1 ? TEXTE.automat : TEXTE.automaten);
  }

  /* Rechenweg: "2 x 150 EUR + 3 x 250 EUR" (mit Malzeichen, U+00A0 und Eurozeichen) */
  function rechnungText(anzahl, praemie1, praemieAb3) {
    var a = aufteilung(anzahl);
    var teile = [];
    if (a.vor > 0) teile.push(a.vor + NBSP + MAL + NBSP + betragText(praemie1));
    if (a.ab > 0) teile.push(a.ab + NBSP + MAL + NBSP + betragText(praemieAb3));
    return teile.join(' + ');
  }

  /* Wer hat gesendet? Anker der Rueckleitung gegen die eigene Formular-id */
  function postZustand(hash, formId) {
    var h = String(hash === null || hash === undefined ? '' : hash).replace(/^#/, '');
    if (!h) return 'unbekannt';
    return h === formId ? 'eigen' : 'fremd';
  }

  var api = {
    VERSION: VERSION,
    STAFFEL_AB: STAFFEL_AB,
    aufteilung: aufteilung,
    praemienSumme: praemienSumme,
    formatZahl: formatZahl,
    betragText: betragText,
    anzahlText: anzahlText,
    rechnungText: rechnungText,
    postZustand: postZustand
  };

  if (typeof module === 'object' && module && module.exports) {
    module.exports = api;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.programm) return;
  MV.programm = api;

  /* ------------------------------------------------------------ 1. Praemienrechner */

  function daten(root) {
    var block = root.querySelector('script[data-mv-praemie-daten]');
    if (!block) return null;
    try {
      var d = JSON.parse(block.textContent || '{}');
      return d && typeof d === 'object' ? d : null;
    } catch (e) {
      return null;
    }
  }

  function setzeText(el, wert) {
    if (el && el.textContent !== wert) el.textContent = wert;
  }

  function aktualisiere(root) {
    if (!root || !root.querySelector) return;
    var d = daten(root);
    var regler = root.querySelector('[data-mv-praemie-regler]');
    if (!d || !regler) return;
    var n = ganzeZahl(regler.value);
    if (!isFinite(n) || n < 1) n = 1;
    setzeText(root.querySelector('[data-mv-praemie-anzahl]'), anzahlText(n));
    setzeText(root.querySelector('[data-mv-praemie-summe]'), betragText(praemienSumme(n, d.praemie_1, d.praemie_ab_3)));
    setzeText(root.querySelector('[data-mv-praemie-rechnung]'), rechnungText(n, d.praemie_1, d.praemie_ab_3));
    regler.setAttribute('aria-valuetext', anzahlText(n));
  }

  function rechnerBereit(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    var liste = wurzel.querySelectorAll('[data-mv-praemie]');
    for (var i = 0; i < liste.length; i++) {
      var steuerung = liste[i].querySelector('[data-mv-praemie-steuerung]');
      if (steuerung && daten(liste[i])) steuerung.hidden = false;
      aktualisiere(liste[i]);
    }
  }

  function beiEingabe(event) {
    var ziel = event.target;
    if (!ziel || !ziel.closest || !ziel.closest('[data-mv-praemie-regler]')) return;
    aktualisiere(ziel.closest('[data-mv-praemie]'));
  }

  /* ------------------------------------------------------------ 2. Bewerbungsformular */

  function gepostet() {
    return /(?:^|[?&])contact_posted=true(?:&|$)/.test(String(location.search || '').replace(/^\?/, ''));
  }

  function verbergen(liste) {
    for (var i = 0; i < liste.length; i++) liste[i].hidden = true;
  }

  function lightboxSchliessen() {
    var dlg = document.getElementById('mv-anfrage');
    if (!dlg || !dlg.hasAttribute('open')) return;
    try {
      if (typeof dlg.close === 'function') dlg.close();
    } catch (e) { /* Rueckfall unten */ }
    if (dlg.hasAttribute('open')) dlg.removeAttribute('open');
  }

  function melden(programm) {
    if (!window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) return;
    try {
      window.Shopify.analytics.publish('mv_bewerbung_gesendet', { programm: programm, pfad: location.pathname });
    } catch (e) { /* Messung darf nichts stoeren */ }
  }

  function formularAbgleich(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    var liste = wurzel.querySelectorAll('[data-mv-bewerbung]');
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      var status = el.getAttribute('data-mv-bewerbung-status') || '';
      if (!status) continue;
      var zustand = postZustand(location.hash, el.getAttribute('data-mv-bewerbung'));
      if (zustand === 'fremd') {
        verbergen(el.querySelectorAll('[data-mv-bewerbung-erfolg], [data-mv-bewerbung-fehler]'));
        var felder = el.querySelector('[data-mv-bewerbung-felder]');
        if (felder) felder.hidden = false;
        el.setAttribute('data-mv-bewerbung-status', '');
      } else if (zustand === 'eigen' && status === 'erfolg' && gepostet()) {
        lightboxSchliessen();
        var fokus = el.querySelector('[data-mv-bewerbung-fokus]');
        if (fokus && typeof fokus.focus === 'function') {
          try { fokus.focus({ preventScroll: true }); } catch (e) { fokus.focus(); }
        }
        melden(el.getAttribute('data-mv-bewerbung-programm') || '');
      }
    }
  }

  /* ------------------------------------------------------------ 3. Partnerstufen */

  function stufeWaehlen(event) {
    var knopf = event.target && event.target.closest ? event.target.closest('a[data-mv-partnerstufe]') : null;
    if (!knopf) return;
    var wert = knopf.getAttribute('data-mv-partnerstufe');
    var wahl = document.querySelector('select[data-mv-partnerstufe-wahl]');
    if (!wahl || !wert) return;
    for (var i = 0; i < wahl.options.length; i++) {
      if (wahl.options[i].value === wert) {
        wahl.selectedIndex = i;
        break;
      }
    }
  }

  /* ------------------------------------------------------------ Start */

  document.addEventListener('input', beiEingabe);
  document.addEventListener('change', beiEingabe);
  document.addEventListener('click', stufeWaehlen);
  document.addEventListener('shopify:section:load', function (event) {
    rechnerBereit(event.target);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) rechnerBereit(document);
  });

  function start() {
    rechnerBereit(document);
    formularAbgleich(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
